import { createSelector } from "@reduxjs/toolkit";
import type { PostMultiplacerDrofusInterfaceProjectChangeEventsApiResponse as IChangeEventsResponse } from "../../openapi";

export type IChangeEventDetails = IChangeEventsResponse["items"][number];
export const formatChangeDetailsTime = (value?: string | null) => {
  if (!value) return "Ikke registrert";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString("nb-NO");
};

export const selectDrofusChangeDetails = createSelector(
  (event: IChangeEventDetails) => event,
  (event) => ({
    identification: [
      ["Forekomst-ID", String(event.entityId)],
      ["Prosjekt", String(event.projectNo)],
      [
        "Artikkel",
        [event.context.article?.compCode, event.context.article?.name].filter(Boolean).join(" · "),
      ],
      ["Artikkel-ID", event.context.article?.id],
      [
        "Rom",
        [event.context.room?.functionNo, event.context.room?.fullName].filter(Boolean).join(" · "),
      ],
      ["Rom-ID", event.context.room?.id],
      ["Arkitektnummer", event.context.room?.architectNo],
      ["Fag", event.affectedDisciplines.join(", ")],
      ["MMI i lagret kontekst", event.context.occurrence?.mmiCode],
      ["Endringstype", { added: "Ny", updated: "Endret", removed: "Fjernet" }[event.changeType]],
    ],
    timing: [
      ["Oppdaget ved innlesning", formatChangeDetailsTime(event.runStartedAt)],
      ["Forrige innlesning", formatChangeDetailsTime(event.baseRunStartedAt)],
      ["Innlesning fullført", formatChangeDetailsTime(event.runFinishedAt)],
      ["Registrert i endringshistorikken", formatChangeDetailsTime(event.createdAt)],
      ["Tidspunkt i tilknyttet dRofus-logg", formatChangeDetailsTime(event.drofusLog?.time)],
      ["Bruker i tilknyttet dRofus-logg", event.drofusLog?.username],
      ["Loggkobling", event.drofusLog?.confidence],
      ["Loggfelt", event.drofusLog?.field],
      ["Logghandling", event.drofusLog?.action],
      ["Loggkilde", event.drofusLog?.changeSource],
      ["Loggmerknad", event.drofusLog?.note],
    ],
    technical: [
      ["Endrings-ID", event._id],
      ["Innlesnings-ID", event.runId],
      ["Forrige innlesnings-ID", event.baseRunId],
      ["Stabil nøkkel", event.stableKey],
      ["Endringsnøkkel", event.changeKey],
      ["Normalisert felt", event.normalizedPath],
      ["Felt-ID", event.fieldId],
      ["Råfelt-ID", event.rawFieldId],
      ["Feltgruppe", event.group],
      ["Regel-ID", event.ruleId],
      ["Status", event.status],
      ["Alvorlighetsgrad", event.severity],
    ],
    raw: JSON.stringify(event, null, 2),
  })
);
